class Utils {
  constructor () {
    this._mapMonths = months.reduce((result, item, index) => {
      result[item.key] = { ...item, index }
      return result
    }, {})
  }
  getMonthByKey (key) {
    key = key.toLowerCase()
    return this._mapMonths[key]
  }
  getMonthLabels () {
    return months.map(month => month.label)
  }
  getColor () {
    return Utils.getRandomColor()
  }
  static getRandomColor () {
    let numbers = []
    for (let i = 0; i < 3; i++) {
      numbers.push(Utils.randomInteger(0, 255))
    }
    return `rgb(${numbers.join(',')},1)`
  }
  static randomInteger (min, max) {
    let rand = min + Math.random() * (max + 1 - min)
    return Math.floor(rand)
  }
}

export default Utils

const months = [
  {
    key: 'january',
    label: window.app.L10n('january')
  },
  {
    key: 'february',
    label: window.app.L10n('february')
  },
  {
    key: 'march',
    label: window.app.L10n('march')
  },
  {
    key: 'april',
    label: window.app.L10n('april')
  },
  {
    key: 'may',
    label: window.app.L10n('may')
  },
  {
    key: 'june',
    label: window.app.L10n('june')
  },
  {
    key: 'july',
    label: window.app.L10n('july')
  },
  {
    key: 'august',
    label: window.app.L10n('august')
  },
  {
    key: 'september',
    label: window.app.L10n('september')
  },
  {
    key: 'october',
    label: window.app.L10n('october')
  },
  {
    key: 'november',
    label: window.app.L10n('november')
  },
  {
    key: 'december',
    label: window.app.L10n('december')
  }
]
